//import React from 'react';
//import '../App.css';
//import { slide as Menu } from 'react-burger-menu';
//import logo from '../img/logo.png';
//import { Dropdown } from 'react-bootstrap';
//// 2. 必须导入 bootstrap 样式（否则下拉菜单无样式/功能）
//import 'bootstrap/dist/css/bootstrap.min.css';
//
//// import { StickyContainer, Sticky } from 'react-sticky';
//// import Journey from "../pages/Journey";
//// import JourneyImage from "./JourneyImage";
//
//// export default function Nav() {
////     const nameStyle={
////         paddingTop:"8vh",
////         fontFamily:"中国式手写风",
////         fontSize:"15pt",
////         paddingBottom:"1vh"
////
////     }
////     const nameStyle2={
////         paddingTop:"2vh",
////         fontFamily:"中国式手写风",
////         fontSize:"15pt",
////         paddingBottom:"1vh",
////         backgroundColor:"white"
////     }
////
////     const navStyle={
////         minWidth:"10vw",
////         listStyle:"none",
////         paddingTop: "15pt",
////         paddingBottom:"18pt",
////         fontSize: "10pt",
////         margin:0,
////
////     }
////     const navStyle2={
////         minWidth:"10vw",
////         listStyle:"none",
////         paddingBottom:"18pt",
////         fontSize: "10pt",
////         margin:0,
////         backgroundColor:"white"
////     }
////
////     const liStyle={
////         display:"inline",
////         paddingRight:"30pt",
////         lineHeight:"10pt"
////     }
////     const table={
////         display:"table",
////         margin:0,
////         width:"100vw",
////
////     }
////     return(
////         <div>
////             <StickyContainer>
////                 <header>
////                     <div style={nameStyle}>
////                         BRANDON LAI
////                     </div>
////                     <div style={table}>
////                         <ul style={navStyle}>
////                             <a href={"/"}>
////                                 <li style={liStyle}>Background_paint</li>
////                             </a>
////                             <a href={"/works/other_works"}><li style={liStyle}>other_works</li></a>
////                             <a href={"/works/Personal"}><li style={liStyle}>Personal</li></a>
////                             <a href={"/about"}><li style={liStyle}>about</li></a>
////                             <a href={"/contact"}><li style={liStyle}>contact</li></a>
////                         </ul>
////                     </div>
////                 </header>
////                 <JourneyImage/>
////                 <Sticky topOffset={80}>
////                 {({
////                       style,
////                   }) => (
////                     <header style={style}>
////                         <div style={nameStyle2}>
////                             BRANDON LAI
////                         </div>
////                         <div style={table}>
////                             <ul style={navStyle2}>
////                                 <a href={"/"}>
////                                     <li style={liStyle}>Background_paint</li>
////                                 </a>
////                                 <a href={"/works/other_works"}><li style={liStyle}>other_works</li></a>
////                                 <a href={"/works/Personal"}><li style={liStyle}>Personal</li></a>
////                                 <a href={"/about"}><li style={liStyle}>about</li></a>
////                                 <a href={"/contact"}><li style={liStyle}>contact</li></a>
////                             </ul>
////                         </div>
////                     </header>
////                 )}
////                 </Sticky>
////             </StickyContainer>
////
////         </div>)
//// }
//export default class Nav extends React.Component{
//    constructor() {
//        super();
//        this.state = {
//            width: window.innerWidth,
//        };
//    }
//
//    componentWillMount() {
//        window.addEventListener('resize', this.handleWindowSizeChange);
//    }
//
//// make sure to remove the listener
//// when the component is not mounted anymore
//    componentWillUnmount() {
//        window.removeEventListener('resize', this.handleWindowSizeChange);
//    }
//
//    handleWindowSizeChange = () => {
//        this.setState({ width: window.innerWidth });
//    };
//    showSettings (event) {
//        event.preventDefault();
//
//    }
//
//    render(){
//    const nameStyle={
//        objectFit:"cover",
//        paddingBottom:"0.1vh",
//        display:"block",
//        marginLeft:"auto",
//        marginRight:"auto",
//        paddingTop:"3%"
//    }
//
//    let liStyle={
//        paddingInline:"5pt",
//        fontFamily:"华文细黑",
//        display:"inline",
//    }
//    const table={
//        display:"table",
//        margin:0,
//        width:"100vw",
//
//    }
//    const emailStyle={
//        fontFamily:"华文细黑",
//        paddingTop:"5pt",
//        display:"inline",
//        lineHeight:"10pt"
//    }
//        const { width } = this.state;
//        const isMobile = width <= 768;
//        const isMiddleScreen = width <= 1366;
//        if (isMobile){ let imageStyle={width:"50%",display:"block",
//            marginRight:"auto",objectFit:"cover",paddingTop:"5%",paddingLeft:"12%",marginLeft: 0,
//            paddingBottom:"0",}
//        return (
//            <div >
//                <Menu right >
//                    <div style={{paddingTop:"40%",overflowX:"hidden"}}></div>
//                       <Dropdown>
//                                                   <Dropdown.Toggle
//                                                       variant="success"
//                                                       id="dropdown-basic"
//                                                       style={{ backgroundColor: "transparent", border: "none", padding: 0 }}
//                                                   >
//                                                       <a href={"/works/background_layout"} style={{ color: "white", padding: "0.8em", display: "block" }}>Background Layout</a>
//                                                   </Dropdown.Toggle>
//                                                   <Dropdown.Menu>
//                                                       <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
//                                                       <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
//                                                       <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
//                                                   </Dropdown.Menu>
//                                               </Dropdown> {/* 关键：补上这个闭合标签，之前漏了 */}
//                        <a href={"/works/background_layout"} style={{color:"white",padding:"0.8em",display:"block"}}>Background Layout</a>
//                        <a href={"/works/background_paint"}style={{color:"white",padding:"0.8em",display:"block"}}>Background Paint
//                        </a>
//                        <a href={"/works/other_works"} style={{color:"white",padding:"0.8em",display:"block"}}>Other Works</a>
//                        <a href={"/works/personal"} style={{color:"white",padding:"0.8em",display:"block"}}>Personal</a>
//                        <a href={"/about"} style={{color:"white",padding:"0.8em",display:"block"}}>about</a>
//                </Menu>
//                <a href={"/"}><img id="page-wrap" style={imageStyle} src={logo}  alt={"Logo"}>
//                </img></a>
//                <div id="page-wrap" style={{paddingLeft:"12%",paddingRight:"auto", fontFamily:"华文细黑",display:"block",width:"50%",marginTop:0,marginLeft:0,marginRight:"auto",paddingTop:"3%",textAlign:"left"}}>orenjikun.art@gmail.com</div>
//
//            </div>
//        );}
//        let navStyle2={
//            fontSize: "11pt",}
//        if (isMiddleScreen){
//
//                return (
//            <div>
//            <a href={"/"}><img src={logo} style={nameStyle} alt={"Logo"}>
//            </img></a>
//                <div style={emailStyle}>
//                    orenjikun.art@gmail.com</div>
//            <div style={table}>
//                <ul style={navStyle2}>
//                    <a href={"/works/background_layout"}><li style={liStyle}>Background Layout</li></a>
//                    <a href={"/works/background_paint"}>
//                        <li style={liStyle}>Background Paint</li>
//                    </a>
//                    <a href={"/works/other_works"}><li style={liStyle}>Other Works</li></a>
//                    <a href={"/works/personal"}><li style={liStyle}>Personal</li></a>
//                    <a href={"/about"}><li style={liStyle}>about</li></a>
//                </ul>
//            </div>
//        </div>);}
//        else{
//            let liStyle={
//                paddingInline:"1em",
//                fontFamily:"华文细黑",
//                display:"inline",}
//
//            let navStyle={
//                minWidth:"10vw",
//                listStyle:"none",
//                paddingTop: "5pt",
//                paddingBottom:"18pt",
//                fontSize: "15pt",
//                margin:0,
//                backgroundColor:"white"
//            }
//    return(
//        <div>
//            <a href={"/"}><img src={logo} style={nameStyle} alt="logo" border="0"/></a>
//            <div style={emailStyle}>
//                orenjikun.art@gmail.com</div>
//            <div style={table}>
//                <ul style={navStyle}>
//                    <a href={"/works/background_layout"}><li style={liStyle}>Background Layout</li></a>
//                    <a href={"/works/background_paint"}>
//                        <li style={liStyle}>Background Paint</li>
//                        </a>
//                    <a href={"/works/other_works"}><li style={liStyle}>Other Works</li></a>
//                    <a href={"/works/personal"}><li style={liStyle}>Personal</li></a>
//                    <a href={"/about"}><li style={liStyle}>about</li></a>
//                </ul>
//            </div>
//        </div> );}
//    }}
//// const nameStyle={
////     paddingTop:"8vh",
////     fontFamily:"中国式手写风",
////     fontSize:"15pt",
////     paddingBottom:"1vh"
////
//// }
////
//// const navStyle={
////     minWidth:"10vw",
////     listStyle:"none",
////     paddingTop: "5pt",
////     paddingBottom:"18pt",
////     fontSize: "10pt",
////     margin:0,
////
//// }
//
//// const liStyle={
////     display:"inline",
////     paddingRight:"30pt",
////     lineHeight:"10pt"
//// }
//// const table={
////     display:"table",
////     margin:0,
////     width:"100vw",
////
//// }
//// return(
////     <div>
////         <div style={nameStyle}>
////             BRANDON LAI
////         </div>
////         <div style={table}>
////             <ul style={navStyle}>
////                 <a href={"/"}>
////                     <li style={liStyle}>WORK</li>
////                 </a>
////                 <a href={"/about"}><li style={liStyle}>ABOUT</li></a>
////                 <a href={"/contact"}><li style={liStyle}>CONTACT</li></a>
////             </ul>
////         </div>
////     </div>)
////     const nameStyle={
////         padding:"3% 3% 3%",
////         position:"fixed",
////         fontFamily:"中国式手写风",
////         fontSize:"15pt",
////         paddingBottom:"1vh"
////
////     }
////
////     const navStyle={
////         minWidth:"10vw",
////         listStyle:"none",
////         paddingTop: "100pt",
////         paddingLeft:"3%",
////         fontSize: "10pt",
////         textAlign:"left",
////         position:"fixed",
////         textDecoration:"none"
////
////     }
////
////     const liStyle={
////         paddingBottom:"15pt",
////         lineHeight:"10pt"
////     }
////     const table={
////         display:"table",
////         margin:0,
////         width:"100vw",
////
////     }
////     return(
////         <div>
////             <div style={nameStyle}>
////                 BRANDON LAI
////             </div>
////             <div style={table}>
////                 <ul style={navStyle}>
////                     <a href={"/"}>
////                         <li style={liStyle}>Background_paint</li>
////                     </a>
////                     <a href={"/works/other_works"}><li style={liStyle}>other_works</li></a>
////                     <a href={"/works/Personal"}><li style={liStyle}>Personal</li></a>
////                     <a href={"/about"}><li style={liStyle}>ABOUT</li></a>
////                     <a href={"/contact"}><li style={liStyle}>CONTACT</li></a>
////                 </ul>
////             </div>
////         </div>
////     )
//// }

import React from 'react';
import '../App.css';
import { slide as Menu } from 'react-burger-menu';
import logo from '../img/logo.png';

export default class Nav extends React.Component {
    constructor() {
        super();
        this.state = {
            width: window.innerWidth,
        };
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    showSettings(event) {
        event.preventDefault();
    }

    render() {
        const nameStyle = {
            objectFit: "cover",
            paddingBottom: "0.1vh",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            paddingTop: "3%"
        };

        // 去掉所有链接的下划线
        let liStyle = {
            paddingInline: "5pt",
            fontFamily: "华文细黑",
            display: "inline",
            textDecoration: "none",
            color: "black"
        };
        const table = {
            display: "table",
            margin: 0,
            width: "100vw",
        };
        const emailStyle = {
            fontFamily: "华文细黑",
            paddingTop: "5pt",
            display: "inline",
            lineHeight: "10pt"
        };

        const { width } = this.state;
        const isMobile = width <= 768;
        const isMiddleScreen = width <= 1366;

        // ========== 移动端侧边栏（完全修复语法错误） ==========
        if (isMobile) {
            let imageStyle = {
                width: "50%",
                display: "block",
                marginRight: "auto",
                objectFit: "cover",
                paddingTop: "5%",
                paddingLeft: "12%",
                marginLeft: 0,
                paddingBottom: "0",
            };
            return (
                <div>
                    <Menu right>
                        <div style={{ paddingTop: "40%", overflowX: "hidden" }}></div>
                        {/* Background Layout 普通链接 */}
                        <a href={"/works/background_layout"} style={{ color: "white", padding: "0.8em", display: "block", textDecoration: "none" }}>Background Layout</a>
                        {/* 其他链接 */}
                        <a href={"/works/background_paint"} style={{ color: "white", padding: "0.8em", display: "block", textDecoration: "none" }}>Background Paint</a>
                        <a href={"/works/other_works"} style={{ color: "white", padding: "0.8em", display: "block", textDecoration: "none" }}>Other Works</a>
                        <a href={"/works/personal"} style={{ color: "white", padding: "0.8em", display: "block", textDecoration: "none" }}>Personal</a>
                        <a href={"/about"} style={{ color: "white", padding: "0.8em", display: "block", textDecoration: "none" }}>about</a>
                    </Menu>
                    <a href={"/"}><img id="page-wrap" style={imageStyle} src={logo} alt={"Logo"}></img></a>
                    <div id="page-wrap" style={{ paddingLeft: "12%", paddingRight: "auto", fontFamily: "华文细黑", display: "block", width: "50%", marginTop: 0, marginLeft: 0, marginRight: "auto", paddingTop: "3%", textAlign: "left" }}>orenjikun.art@gmail.com</div>
                </div>
            );
        }

        // ========== 中等屏幕（平板）导航栏 ==========
        let navStyle2 = {
            fontSize: "11pt",
            listStyle: "none",
            paddingTop: "5pt",
            paddingBottom: "18pt",
            margin: 0,
            backgroundColor: "white"
        };
        if (isMiddleScreen) {
            return (
                <div>
                    <a href={"/"}><img src={logo} style={nameStyle} alt={"Logo"}></img></a>
                    <div style={emailStyle}>
                        orenjikun.art@gmail.com</div>
                    <div style={table}>
                        <ul style={navStyle2}>
                            {/* Background Layout 普通链接 */}
                            <a href={"/works/background_layout"} style={{ textDecoration: "none", color: "black" }}>
                                <li style={liStyle}>Background Layout</li>
                            </a>
                            {/* 其他链接 */}
                            <a href={"/works/background_paint"} style={{ textDecoration: "none", color: "black" }}>
                                <li style={liStyle}>Background Paint</li>
                            </a>
                            <a href={"/works/other_works"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>Other Works</li></a>
                            <a href={"/works/personal"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>Personal</li></a>
                            <a href={"/about"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>about</li></a>
                        </ul>
                    </div>
                </div>);
        } else {
            // ========== 大屏幕（PC）导航栏 ==========
            let liStyle = {
                paddingInline: "1em",
                fontFamily: "华文细黑",
                display: "inline",
                textDecoration: "none",
                color: "black"
            };

            let navStyle = {
                minWidth: "10vw",
                listStyle: "none",
                paddingTop: "5pt",
                paddingBottom: "18pt",
                fontSize: "15pt",
                margin: 0,
                backgroundColor: "white"
            };
            return (
                <div>
                    <a href={"/"}><img src={logo} style={nameStyle} alt="logo" border="0" /></a>
                    <div style={emailStyle}>
                        orenjikun.art@gmail.com</div>
                    <div style={table}>
                        <ul style={navStyle}>
                            {/* Background Layout 普通链接 */}
                            <a href={"/works/background_layout"} style={{ textDecoration: "none", color: "black" }}>
                                <li style={liStyle}>Background Layout</li>
                            </a>
                            {/* 其他链接 */}
                            <a href={"/works/background_paint"} style={{ textDecoration: "none", color: "black" }}>
                                <li style={liStyle}>Background Paint</li>
                            </a>
                            <a href={"/works/other_works"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>Other Works</li></a>
                            <a href={"/works/personal"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>Personal</li></a>
                            <a href={"/about"} style={{ textDecoration: "none", color: "black" }}><li style={liStyle}>about</li></a>
                        </ul>
                    </div>
                </div>);
        }
    }
}